import React from "react";
import { useTranslation } from "react-i18next";
import Container from "react-bootstrap/Container";

import { Title } from "./common/Title";

import styles from "../assets/styles/speciality.module.scss";

import orthodontics from "../assets/images/specialities/orthodontics.jpg";
import implantology from "../assets/images/specialities/implantology.jpg";
import periodontology from "../assets/images/specialities/periodontology.jpg";
import cirurgy from "../assets/images/specialities/cirurgy.jpg";
import whitening from "../assets/images/specialities/whitening.jpg";
import prosthesis from "../assets/images/specialities/prosthesis.jpg";

interface ISpecialityProps {
  title: string;
  description: string;
  image: string;
}

function Speciality(props: ISpecialityProps){
  return (
    <div className="img-max-width col">
            <div className={styles.itemBox}>
              <a href="#!">
                <img className={`${styles.itemContainer} img-fluid`} src={props.image} alt={props.title} />
                <div className={styles.itemMask}>
                  <div className="item-caption">
                    <h5 className="text-dark">{props.title}</h5>
                    <span className="text-muted">{props.description}</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
  );
}

export function Specialities() {
  const { t, i18n } = useTranslation("specialities");

  return (
    <section id="specialities" className={styles.specialities}>
      <Container data-aos="fade-up">
        <Title title={t("title")} />
        <div className="container-grid row-cols-xl-3 row-cols-lg-2 row-cols-1 g-0 row">
          <Speciality title={t("orthodonticsTitle")} description={t("orthodonticsDescription")} image={orthodontics}/>
          <Speciality title={t("implantologyTitle")} description={t("implantologyDescription")} image={implantology}/>
          <Speciality title={t("periodontologyTitle")} description={t("periodontologyDescription")} image={periodontology}/>
          <Speciality title={t("cirurgyTitle")} description={t("cirurgyDescription")} image={cirurgy}/>
          <Speciality title={t("whiteningTitle")} description={t("whiteningDescription")} image={whitening}/>
          <Speciality title={t("prosthesisTitle")} description={t("prosthesisDescription")} image={prosthesis}/>
        </div>
      </Container>
    </section>
  );
}
